import { render, staticRenderFns } from "./WebhookTable.vue?vue&type=template&id=5773a643&"
import script from "./WebhookTable.vue?vue&type=script&lang=js&"
export * from "./WebhookTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports